import { type FieldError, HttpError } from './http-error';
import type { HttpStatusCode } from './types';

function makeError<T = string | undefined>(
  code: string,
  status: HttpStatusCode,
) {
  return class extends HttpError<T> {
    constructor(
      message?: string,
      _details?: T,
      options?: { kind?: string; fieldErrors?: FieldError[] },
    ) {
      super(status, code, message, options);
    }
  };
}

export const BadRequestError = makeError('BadRequest', 400);
export const NotAuthorizedError = makeError('NotAuthorized', 401);
export const ForbiddenError = makeError('Forbidden', 403);
export const NotFoundError = makeError('NotFound', 404);
export const MethodNotAllowedError = makeError('MethodNotAllowed', 405);
export const ConflictError = makeError('Conflict', 409);
export const UnprocessableEntityError = makeError('UnprocessableEntity', 422);
export const TooManyRequestsError = makeError('TooManyRequests', 429);
export const InternalServerError = makeError('InternalServerError', 500);

export { HttpError };
